module.exports = __webpack_public_path__ + "img/schedule.5ca708e2.png";